import { backgroundTransitionOnClick } from '@byecode/ui'
import styled from 'styled-components'

export const FileItem = styled.div`
    width: 100%;
    /* display: flex;
    align-items: center;
    justify-content: space-between; */
    /* height: 65px; */
    /* padding: 12px; */
    /* background-color: var(--color-white); */
    color: var(--color-black);
    border: 1px solid var(--color-gray-200);
    border-radius: 8px;
`

export const Item = styled.div`
    width: 100%;
    height: 52px;
    line-height: 52px;
    text-align: center;
    background-color: var(--color-white);
    font-size: var(--font-size-base);
    color: var(--color-black);
    ${backgroundTransitionOnClick}
`

export const Footer = styled.div`
    width: 100%;
    padding: 16px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color-gray-50);
    z-index: 1;
`
